import React from "react";
import { Section } from "components/core/Page";
import { H3, Paragraph, Text } from "components/core/Typography";
import { Filter, MapPinFilled, Phone } from "components/core/Icons";
import { ClickToCall } from "components/brand/ClickToCall";
import noResults from "assets/images/no-results.svg";
import { useTollfreeNumber } from "hooks/useTollfreeNumber";
import "./NoResults.scss";

const NoResults = () => {
	const { phone, handleFetchNumber } = useTollfreeNumber();
	return (
		<Section className="no-results">
			<img
				alt="no results"
				src={noResults}
			/>
			<div className="text">
				<H3
					size="xlarge"
					mediumSize="large"
				>
					No Storage Facilities
					<br />
					Were Found
				</H3>
				<Paragraph>
					Don&lsquo;t worry! We can help you get back on track.
				</Paragraph>
				<div className="options">
					<Filter fill="darkGray" />
					<Text>Update your filters</Text>
					<MapPinFilled fill="darkGray" />
					<Text>Search for a more specific location</Text>
					<Phone fill="darkGray" />
					<Text>
						Still having trouble finding the perfect storage?
						<br />
						Call us at:
						<ClickToCall
							showIcon={false}
							handleFetchNumber={handleFetchNumber}
							phone={phone}
						/>
					</Text>
				</div>
			</div>
		</Section>
	);
};

export default NoResults;
